import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./Training.css";
import Testimonial from "../../../Testimonial/Testimonial";

const Training = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    // Set initial container width
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1; // Adjust speed as needed (pixels per frame)

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  return (
    <div>
      <Helmet>
        <title>
          Technical Training Programs | Comprehensive Tech Stack Courses
        </title>
        <meta
          name="description"
          content="Professional training programs covering the latest technologies including web development, mobile apps, blockchain, AI, and data science. Hands-on courses with industry experts."
        />
        <meta
          name="keywords"
          content="technical training, coding bootcamp, programming courses, web development training, mobile app development course, blockchain education, AI training, data science certification, Angular training, React.js course, JavaScript programming, HTML5 CSS3 training, Bootstrap framework, Node.js certification, Python programming, PHP development, database training, MongoDB course, MySQL certification, Ethereum development, smart contracts training, Hyperledger framework, Flutter app development, React Native course, Ionic framework, artificial intelligence classes, machine learning certification, IoT training, Internet of Things course, augmented reality development, virtual reality programming, cloud computing training, AWS certification, Azure training, full-stack development bootcamp, frontend development course, backend programming, UI/UX design training, software engineering certification, IT skills development, tech career training, coding skills improvement, professional certification programs, hands-on technical training, industry-relevant courses, emerging technologies education"
        />
      </Helmet>

      <div className="mketech-training">
        <div className="mketech-training-hero">
          <div className="mketech-hero-content">
            <h1 className="mketech-hero-title">
              Professional Training Programs
            </h1>
            <p className="mketech-hero-subtitle">
              Empowering your team with cutting-edge technology skills
            </p>
            <a
              href="https://wa.me/919155599968?text=Hi!%20I%20am%20interested%20in%20your%20training%20programs%20and%20courses.%20Please%20share%20details%20about%20available%20modules%2C%20schedule%2C%20and%20fees."
              target="_blank"
              rel="noreferrer"
            >
              <button className="mketech-cta-button">
                Explore Our Courses
              </button>
            </a>
          </div>
          <div className="mketech-hero-animation">
            <div className="mketech-animation-circle"></div>
            <div className="mketech-animation-square"></div>
            <div className="mketech-animation-triangle"></div>
          </div>
        </div>

        <div className="mketech-training-courses">
          <h2 className="mketech-section-title">Our Training Programs</h2>
          <div className="mketech-courses-container">
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-webdev"></i>
              </div>
              <h3 className="mketech-card-title">Web Development</h3>
              <p className="mketech-card-desc">
                Master frontend and backend technologies including React,
                Node.js, and modern frameworks.
              </p>
              <ul className="mketech-card-features">
                <li>HTML5, CSS3, JavaScript ES6+</li>
                <li>React.js & Next.js</li>
                <li>Node.js & Express</li>
                <li>Database Integration</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-data"></i>
              </div>
              <h3 className="mketech-card-title">Data Science</h3>
              <p className="mketech-card-desc">
                Learn to extract insights from data using Python, R, machine
                learning, and statistical analysis.
              </p>
              <ul className="mketech-card-features">
                <li>Python for Data Analysis</li>
                <li>Machine Learning Algorithms</li>
                <li>Data Visualization</li>
                <li>Statistical Modeling</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-cloud"></i>
              </div>
              <h3 className="mketech-card-title">Cloud Computing</h3>
              <p className="mketech-card-desc">
                Gain expertise in cloud platforms like AWS, Azure, and Google
                Cloud with hands-on training.
              </p>
              <ul className="mketech-card-features">
                <li>AWS Services</li>
                <li>Azure Infrastructure</li>
                <li>Cloud Security</li>
                <li>DevOps Practices</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 1: Cybersecurity */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-cyber"></i>
              </div>
              <h3 className="mketech-card-title">Cybersecurity</h3>
              <p className="mketech-card-desc">
                Protect digital assets and master the art of ethical hacking,
                network security, and threat detection.
              </p>
              <ul className="mketech-card-features">
                <li>Ethical Hacking Techniques</li>
                <li>Network Defense Strategies</li>
                <li>Security Audit & Compliance</li>
                <li>Incident Response</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 2: Mobile App Development */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-mobile"></i>
              </div>
              <h3 className="mketech-card-title">Mobile App Development</h3>
              <p className="mketech-card-desc">
                Build cross-platform mobile applications using React Native,
                Flutter, and native development approaches.
              </p>
              <ul className="mketech-card-features">
                <li>React Native & Flutter</li>
                <li>iOS & Android Development</li>
                <li>UI/UX for Mobile</li>
                <li>App Store Deployment</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 3: Digital Marketing */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-digital"></i>
              </div>
              <h3 className="mketech-card-title">Digital Marketing</h3>
              <p className="mketech-card-desc">
                Master SEO, social media marketing, content strategy, and
                analytics to drive business growth.
              </p>
              <ul className="mketech-card-features">
                <li>SEO & SEM Strategies</li>
                <li>Social Media Marketing</li>
                <li>Content Marketing</li>
                <li>Google Analytics</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 4: UI/UX Design */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-uiux"></i>
              </div>
              <h3 className="mketech-card-title">UI/UX Design</h3>
              <p className="mketech-card-desc">
                Create intuitive and engaging user experiences with modern
                design principles and tools.
              </p>
              <ul className="mketech-card-features">
                <li>User Research Methods</li>
                <li>Wireframing & Prototyping</li>
                <li>Interaction Design</li>
                <li>Design Systems</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 5: AI & Machine Learning */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-ai"></i>
              </div>
              <h3 className="mketech-card-title">AI & Machine Learning</h3>
              <p className="mketech-card-desc">
                Dive deep into artificial intelligence, neural networks, and
                advanced machine learning techniques.
              </p>
              <ul className="mketech-card-features">
                <li>Neural Networks & Deep Learning</li>
                <li>Natural Language Processing</li>
                <li>Computer Vision</li>
                <li>Reinforcement Learning</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 6: Blockchain Development */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-blockchain"></i>
              </div>
              <h3 className="mketech-card-title">Blockchain Development</h3>
              <p className="mketech-card-desc">
                Learn to build decentralized applications and smart contracts on
                various blockchain platforms.
              </p>
              <ul className="mketech-card-features">
                <li>Smart Contract Development</li>
                <li>Ethereum & Solidity</li>
                <li>DApp Architecture</li>
                <li>Cryptocurrency Fundamentals</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 7: DevOps Engineering */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-devops"></i>
              </div>
              <h3 className="mketech-card-title">DevOps Engineering</h3>
              <p className="mketech-card-desc">
                Master the tools and practices for automating development,
                testing, and deployment processes.
              </p>
              <ul className="mketech-card-features">
                <li>CI/CD Pipelines</li>
                <li>Containerization with Docker</li>
                <li>Kubernetes Orchestration</li>
                <li>Infrastructure as Code</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 8: IoT Development */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-iot"></i>
              </div>
              <h3 className="mketech-card-title">IoT Development</h3>
              <p className="mketech-card-desc">
                Build connected devices and systems that collect and exchange
                data in the Internet of Things ecosystem.
              </p>
              <ul className="mketech-card-features">
                <li>Sensor Integration</li>
                <li>Edge Computing</li>
                <li>IoT Protocols</li>
                <li>Cloud Connectivity</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 9: Game Development */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-game"></i>
              </div>
              <h3 className="mketech-card-title">Game Development</h3>
              <p className="mketech-card-desc">
                Create immersive games using popular engines and programming
                languages for various platforms.
              </p>
              <ul className="mketech-card-features">
                <li>Unity & Unreal Engine</li>
                <li>Game Mechanics Design</li>
                <li>3D Modeling Basics</li>
                <li>VR/AR Development</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 10: Software Testing */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-testing"></i>
              </div>
              <h3 className="mketech-card-title">Software Testing</h3>
              <p className="mketech-card-desc">
                Master various testing methodologies and tools to ensure
                software quality and reliability.
              </p>
              <ul className="mketech-card-features">
                <li>Test Automation</li>
                <li>Performance Testing</li>
                <li>Security Testing</li>
                <li>Test-Driven Development</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 11: Quantum Computing */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-quantum"></i>
              </div>
              <h3 className="mketech-card-title">Quantum Computing</h3>
              <p className="mketech-card-desc">
                Explore the fundamentals of quantum mechanics applied to
                computing and quantum algorithm development.
              </p>
              <ul className="mketech-card-features">
                <li>Qubits & Quantum Gates</li>
                <li>Quantum Algorithms</li>
                <li>Quantum Cryptography</li>
                <li>Quantum Machine Learning</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>

            {/* New Training Program 12: Robotics & Automation */}
            <div className="mketech-course-card">
              <div className="mketech-card-icon">
                <i className="mketech-icon-robotics"></i>
              </div>
              <h3 className="mketech-card-title">Robotics & Automation</h3>
              <p className="mketech-card-desc">
                Design, build, and program robotic systems and automated
                solutions for various industries.
              </p>
              <ul className="mketech-card-features">
                <li>Robot Programming</li>
                <li>Computer Vision for Robotics</li>
                <li>Industrial Automation</li>
                <li>ROS (Robot Operating System)</li>
              </ul>
              <button className="mketech-card-button">Learn More</button>
            </div>
          </div>
        </div>

<div className="mketech-training-benefits">
  <h2 className="mketech-section-title">Why Choose Our Training?</h2>
  <div className="mketech-benefits-grid">
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-expert"></i>
      </div>
      <h3>Expert Instructors</h3>
      <p>
        Learn from industry professionals with years of practical
        experience.
      </p>
    </div>
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-handsOn"></i>
      </div>
      <h3>Hands-on Projects</h3>
      <p>
        Apply your knowledge through real-world projects and case
        studies.
      </p>
    </div>
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-career"></i>
      </div>
      <h3>Career Support</h3>
      <p>
        Get assistance with resume building, interview prep, and job
        placement.
      </p>
    </div>
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-flexible"></i>
      </div>
      <h3>Flexible Learning</h3>
      <p>
        Choose from online, in-person, or hybrid learning options to fit
        your schedule.
      </p>
    </div>
    
    {/* New Benefit 1: Industry-Recognized Certification */}
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-certification"></i>
      </div>
      <h3>Industry-Recognized Certification</h3>
      <p>
        Earn valuable certifications that are recognized by top employers
        in the industry.
      </p>
    </div>
    
    {/* New Benefit 2: Latest Curriculum */}
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-curriculum"></i>
      </div>
      <h3>Latest Curriculum</h3>
      <p>
        Learn the most up-to-date technologies and methodologies used in
        the industry today.
      </p>
    </div>
    
    {/* New Benefit 3: Personalized Attention */}
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-personalized"></i>
      </div>
      <h3>Personalized Attention</h3>
      <p>
        Small batch sizes ensure individual attention and customized
        learning paths.
      </p>
    </div>
    
    {/* New Benefit 4: Lifetime Access */}
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-lifetime"></i>
      </div>
      <h3>Lifetime Access</h3>
      <p>
        Get lifetime access to course materials, updates, and our exclusive
        alumni community.
      </p>
    </div>
    
    {/* New Benefit 5: Networking Opportunities */}
    <div className="mketech-benefit-item">
      <div className="mketech-benefit-icon">
        <i className="mketech-icon-networking"></i>
      </div>
      <h3>Networking Opportunities</h3>
      <p>
        Connect with industry experts, alumni, and peers through our
        exclusive events and forums.
      </p>
    </div>
  </div>
</div>

        {/* <div className="mketech-training-testimonials">
          <h2 className="mketech-section-title">What Our Students Say</h2>
          <div className="mketech-testimonials-container">
            <div className="mketech-testimonial">
              <div className="mketech-testimonial-content">
                <p>
                  "The web development course transformed my career. I went from
                  beginner to landing a job in just 6 months!"
                </p>
              </div>
              <div className="mketech-testimonial-author">
                <h4>Rahul Sharma</h4>
                <p>Software Developer at TechSolutions</p>
              </div>
            </div>
            <div className="mketech-testimonial">
              <div className="mketech-testimonial-content">
                <p>
                  "The instructors were amazing! Their real-world experience
                  made all the difference in understanding complex concepts."
                </p>
              </div>
              <div className="mketech-testimonial-author">
                <h4>Priya Patel</h4>
                <p>Data Analyst at DataInsights Inc.</p>
              </div>
            </div>
          </div>
        </div> */}

        <div className="mketech-training-cta">
          <h2>Ready to Transform Your Career?</h2>
          <p>
            Join thousands of students who have accelerated their careers with
            our training programs
          </p>
          <div className="mketech-cta-buttons">
            <a
              href="https://wa.me/919155599968?text=Hi!%20I%20am%20interested%20in%20your%20training%20programs%20and%20courses.%20Please%20share%20details%20about%20available%20modules%2C%20schedule%2C%20and%20fees."
              target="_blank"
              rel="noreferrer"
            >
              <button className="mketech-cta-button">Contact Us</button>
            </a>
          </div>
        </div>
      </div>

      <Testimonial />

      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Training;
